var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return !_vm.isLeaved
    ? _c("div", { staticClass: "modal-cover", on: { click: _vm.onClose } }, [
        _c(
          "div",
          {
            staticClass: "block-member-container",
            on: {
              click: function ($event) {
                $event.stopPropagation()
              },
            },
          },
          [
            _c("div", { staticClass: "block-member-header-container" }, [
              _c("button", {
                staticClass: "close-modal",
                on: { click: _vm.onClose },
              }),
              _c("div", [_vm._v(_vm._s(_vm.$t("camstudy.blockMember.title")))]),
              _c("div", { staticClass: "add-block-member" }),
            ]),
            _c(
              "ul",
              { staticClass: "block-member-body-container" },
              _vm._l(_vm.banUserList, function (banUser) {
                return _c(
                  "li",
                  { key: banUser.banId, staticClass: "block-member-item" },
                  [
                    _c("div", { staticClass: "flex items-center gap-3" }, [
                      _vm.getCamStudyUser(banUser.userId)?.profileImageUrl
                        ? _c("img", {
                            staticClass: "user-image",
                            attrs: {
                              src: _vm.getCamStudyUser(banUser.userId)
                                ?.profileImageUrl,
                              alt: _vm.$t("camstudy.blockMember.user"),
                            },
                          })
                        : _c("div", { staticClass: "user-image none" }),
                      _c("div", { staticClass: "user-email" }, [
                        _vm._v(_vm._s(_vm.maskingEmail(banUser.email))),
                      ]),
                    ]),
                    _c(
                      "button",
                      {
                        staticClass: "unblock-button",
                        on: {
                          click: function ($event) {
                            return _vm.reqRemoveBanUser(banUser)
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.$t("camstudy.blockMember.unblock")))]
                    ),
                  ]
                )
              }),
              0
            ),
          ]
        ),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }